import { ConfigProvider, Input, MenuProps, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AccountGroups.scss';
import { getAccountGroupColumns } from '../../helpers/accountGroupsColumns';
import axios from 'axios';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import { AccountGroup } from '../../models/AccountGroup';
import { useConfigurationContext } from '../../store/configurationContext';
import { SearchOutlined } from '@ant-design/icons';
import { themeConfig } from '../WalletTransactions/config';
import { StyledPagination } from '../../components/table.style';
import Header from '../../components/Header/Header';
const AccountGroups = () => {
	const { t } = useTranslation();
	const [accountGroupsLoading, setAccountGroupsLoading] = useState(false);
	const [accountGroups, setAccountGroups] = useState<AccountGroup[]>([]);
	const [sortBy, setSortBy] = useState('');
	const [searchTerm, setSearchTerm] = useState('');
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const [filterdData, setFilteredData] = useState<AccountGroup[]>([]);
	const reloadDataCallback = () => {
		setAccountGroupsLoading(true);
		axios
			.get(`${API_ENDPOINTS.accountGroupsLimits}`)
			.then((data) => {
				setAccountGroupsLoading(false);
				setAccountGroups(
					data.data.map((el: any) => {
						return {
							tradingPlatform: el.tradingPlatform,
							tradingAccountGroup: el.group,
							...el,
						};
					}),
				);
			})
			.catch((err) => console.error(err));
	};
	useEffect(() => {
		setAccountGroupsLoading(true);
		axios
			.get(`${API_ENDPOINTS.accountGroupsLimits}`)
			.then((data) => {
				setAccountGroupsLoading(false);
				setAccountGroups(
					data.data.map((el: any) => {
						return {
							tradingPlatform: el.tradingPlatform,
							tradingAccountGroup: el.group,
							...el,
						};
					}),
				);
				setFilteredData(
					data.data.map((el: any) => {
						return {
							tradingPlatform: el.tradingPlatform,
							tradingAccountGroup: el.group,
							...el,
						};
					}),
				);
				setTotalElements(data.data.length);
			})
			.catch((err) => console.error(err));
	}, []);
	useEffect(() => {
		const words = searchTerm.split(' ');
		const data = accountGroups.filter((user) =>
			words.every((word) => Object.values(user).some((value) => String(value).toLowerCase().includes(word))),
		);
		setFilteredData(data);
	}, [sortBy, searchTerm]);

	const pageSizeItems: MenuProps['items'] = [
		{ label: '10', key: '1', onClick: () => changeOageSize(10) },
		{ label: '20', key: '2', onClick: () => changeOageSize(20) },
		{ label: '50', key: '3', onClick: () => changeOageSize(50) },
		{ label: '100', key: '4', onClick: () => changeOageSize(100) },
	];
	const changeOageSize = (pageSize: number) => {
		setPage(0);
		setPageSize(pageSize);
	};
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';
	return (
		<div>
			<Header title={t<string>('accountGroupLimits')} description={t<string>('accountGroupLimitsSubtitle')} />
			<div className='min-h-[85vh]  p-5  bg-white'>
				<div className='flex justify-end items-center my-2'>
					<Input
						className='border-none h-10 bg-[#F5F5F5] search-input w-[200px] xss:my-4 lg:my-0'
						placeholder={t<string>('searchAccountGroup')}
						value={searchTerm}
						onChange={(e) => {
							setSearchTerm(e.target.value);
						}}
						size='large'
						prefix={<SearchOutlined className='mr-2' />}
					/>
				</div>
				<ConfigProvider theme={themeConfig}>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							columns={getAccountGroupColumns(t, sortBy, setSortBy, reloadDataCallback)}
							pagination={{
								pageSize,
								total: totalElements,
								onChange: (pageIndex) => setPage(pageIndex - 1),
								current: page + 1,
							}}
							dataSource={filterdData}
							loading={accountGroupsLoading}
							tableLayout='auto'
						/>
					</StyledPagination>
				</ConfigProvider>
			</div>
		</div>
	);
};

export default AccountGroups;
